module.exports = __webpack_public_path__ + "img/NH-Webapp-Test-tube.db4a93a2.gif";